import { store } from "@/store/store";
import axios from "axios";
import { logout } from "@/store/slices/authSlice";

const apiClient = axios.create({
  baseURL: `${import.meta.env.VITE_BACKEND}/api`,
  headers: {
    Accept: "application/json",
    // "Content-Type": "application/json",
  },
  withCredentials: true, 
});

apiClient.interceptors.request.use(
  (config) => {

    config.headers["Accept-Language"] = localStorage.getItem("lang") || "en";
    config.withCredentials =  true
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
        if (error.response.status === 401) {
          store.dispatch(logout());
          window.location.href = "/auth/login";
        } else if (error.response.status === 403) {
          window.location.href = "/dashboard/forbidden";
        } else {
          // Handle other response errors
          console.error("Response error:", error.response);
        }
      } else if (error.request) {
        // Handle request error
        console.error("Request error:", error?.request);
      } else {
        // Handle other errors
        console.error("Error:", error.message);
    }
    return Promise.reject(error?.response?.data);
  }
);

const { get, post, put, patch, delete: destroy } = apiClient;
export { get, post, put, destroy, patch };

export default apiClient;
